import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';
import { fechaLocal } from '../utils/fecha';

// Cierre de Mes: pendientes por pagar (checklist) + sello de mes cerrado.
// Reusa cuentas / gastos (registrar_gasto/eliminar_gasto) del negocio.

// --- Pendientes por pagar ---

export async function obtenerPendientes(ym) {
  let query = supabase
    .from('pendientes_pago')
    .select('*')
    .eq('negocio_id', getNegocioId());
  if (ym) query = query.eq('ym', ym);
  query = query.order('creado_en', { ascending: true });
  const { data, error } = await query;
  if (error) throw error;
  return data || [];
}

export async function agregarPendiente({ ym, concepto, monto, categoria, cuentaId, nota }) {
  const { data, error } = await supabase
    .from('pendientes_pago')
    .insert({
      negocio_id: getNegocioId(),
      ym,
      concepto: (concepto || '').trim(),
      monto: parseFloat(monto) || 0,
      categoria: categoria || null,
      cuenta_id: cuentaId || null,
      nota: (nota || '').trim() || null,
    })
    .select()
    .single();
  if (error) throw error;
  return data;
}

// Edita un pendiente (concepto, monto, categoría, cuenta). Solo para
// pendientes NO pagados: si ya se pagó, hay un gasto asociado y hay que
// desmarcarlo primero (la UI lo impide). RLS del negocio cubre el UPDATE.
export async function actualizarPendiente(id, { concepto, monto, categoria, cuentaId, nota }) {
  const cambios = {};
  if (concepto !== undefined) cambios.concepto = (concepto || '').trim();
  if (monto !== undefined) cambios.monto = parseFloat(monto) || 0;
  if (categoria !== undefined) cambios.categoria = categoria || null;
  if (cuentaId !== undefined) cambios.cuenta_id = cuentaId || null;
  if (nota !== undefined) cambios.nota = (nota || '').trim() || null;
  const { error } = await supabase
    .from('pendientes_pago')
    .update(cambios)
    .eq('id', id)
    .eq('negocio_id', getNegocioId());
  if (error) throw error;
}

// Marca pagado → crea el gasto real desde la cuenta (atómico).
export async function pagarPendiente(id, fecha) {
  const { error } = await supabase.rpc('pagar_pendiente', {
    p_negocio_id: getNegocioId(),
    p_pendiente_id: id,
    p_fecha: fecha || fechaLocal(),
  });
  if (error) throw error;
}

// Desmarca pagado → revierte el gasto (devuelve el dinero a la cuenta).
export async function despagarPendiente(id) {
  const { error } = await supabase.rpc('despagar_pendiente', {
    p_negocio_id: getNegocioId(),
    p_pendiente_id: id,
  });
  if (error) throw error;
}

// Elimina el pendiente (si estaba pagado, revierte su gasto primero).
export async function eliminarPendiente(id) {
  const { error } = await supabase.rpc('eliminar_pendiente', {
    p_negocio_id: getNegocioId(),
    p_pendiente_id: id,
  });
  if (error) throw error;
}

// --- Cierre del mes ---

export async function obtenerCierres() {
  const { data, error } = await supabase
    .from('cierres_mes')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .order('ym', { ascending: true });
  if (error) throw error;
  return data || [];
}

export async function cerrarMes(ym, resumen) {
  const { data, error } = await supabase.rpc('cerrar_mes', {
    p_negocio_id: getNegocioId(),
    p_ym: ym,
    p_resumen: resumen || {},
  });
  if (error) throw error;
  return data;
}

export async function reabrirMes(ym) {
  const { error } = await supabase
    .from('cierres_mes')
    .delete()
    .eq('negocio_id', getNegocioId())
    .eq('ym', ym);
  if (error) throw error;
}
